import { cx } from './cx.ts'

import './feedback.css'

/**
 * 스켈레톤(불러오는 중). ⚠ 와이어프레임에 대응 요소가 없다 — 내가 정했다.
 *
 * 왜 스피너가 아닌가: 표·패널이 뜰 때 높이가 흔들리면 안 된다(§1-2 "높이 고정").
 * 자리를 그대로 차지하는 회색 블록이 그 요구에 맞는다.
 */
export type SkeletonProps = {
  /** 폭. 기본 100% */
  width?: string | undefined
  /** 깜빡임. 기본 true. 모션 감소 설정에서는 토큰이 0ms 라 자동으로 멈춘다 */
  pulse?: boolean | undefined
}

export function Skeleton({ width, pulse = true }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cx('a-skel', pulse && 'a-skel--pulse')}
      style={width === undefined ? undefined : { width }}
    />
  )
}
